// Where the JSON API lives, resolved at runtime.
//
// The dashboard is a static SPA served per-tenant (e.g. verkstad.minbesiktning.se),
// but the Rails API only answers on the `api.` subdomain and kamal-proxy only routes
// `api.`/`dash.`/`hooks.` to the backend. A relative `/api/...` call therefore never
// reaches Rails in production (the static host returns 405). So we target the `api.`
// subdomain of whatever host the dashboard is loaded from:
//
//   verkstad.minbesiktning.se  -> https://api.minbesiktning.se/api
//   verkstad.<uae-domain>      -> https://api.<uae-domain>/api
//
// One build still serves every tenant — the host it runs on decides the backend.
// In local dev we keep the relative path so Vite's dev proxy forwards to :3000.

export function apiBase(): string {
  // Explicit build-time override wins (escape hatch for preview/staging hosts).
  const envUrl = (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_API_URL;
  if (envUrl) return envUrl.replace(/\/$/, "");

  if (typeof window === "undefined") return "/api";

  const { hostname, protocol } = window.location;

  // Local dev — relative path, handled by Vite's proxy (vite.config.ts).
  if (hostname === "localhost" || hostname === "127.0.0.1") return "/api";

  // Production: the API is the `api.` subdomain of the same root domain.
  const labels = hostname.split(".");
  const root = labels.length > 2 ? labels.slice(1).join(".") : hostname;
  return `${protocol}//api.${root}/api`;
}

/** Absolute URL for a raw fetch() against the API, e.g. apiUrl("/auth/request_otp"). */
export function apiUrl(path: string): string {
  return `${apiBase()}${path.startsWith("/") ? path : `/${path}`}`;
}
